import { useState } from 'react';
import Link from 'next/link';
import cn from 'classnames';
import Tooltip from './Tooltip';
import { DefaultOptionProps } from './types';

const DefaultOption = ({
  id,
  queryParams,
  isSelected,
  option,
  suggested,
  handleVariantSelection,
  className,
  handle,
}: DefaultOptionProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  if (handle === 'shaftModel' && suggested) return null;

  return (
    <div className={cn('relative', className)}>
      <Link
        href={{
          pathname: '/collections/[handle]',
          query: queryParams.toString(),
        }}
        scroll={false}
        shallow
      >
        <a
          data-suggested={suggested}
          id={id}
          onMouseEnter={() => {
            if (suggested) setIsTooltipOpen(true);
          }}
          onMouseLeave={() => {
            if (suggested) setIsTooltipOpen(false);
          }}
          onClick={() => {
            setIsTooltipOpen(false);
            handleVariantSelection();
          }}
          className={cn(
            'flex h-10 items-center justify-center rounded border px-2 text-center',
            {
              'border-slate-gray-200 hover:border-gray-700 hover:text-gray-700':
                !isSelected,
              'border-gray-700 font-bold': isSelected,
              'border-dashed text-gray-700/50': suggested,
            },
          )}
        >
          {option}
        </a>
      </Link>
      {isTooltipOpen && <Tooltip />}
    </div>
  );
};

export default DefaultOption;
